<template>
  <div class="scheduleRulesCard" v-if="!info.isIncrease">
    <el-popover
      popper-class="scheduleRulesCard_popper"
      placement="right-start"
      :offset="10"
      :visible-arrow="false"
      trigger="click">
      <div class="popover_info">
        <div :class="{ popover_header: true, physio: info.ruleType === '2' }">
          <div class="popover_header_title">
            <div class="popover_header_title_tag">{{ info.ruleType === '2' ? '理疗执行' : '门诊' }}</div>
            <div class="popover_header_title_time">{{ timeTypeMap[info.ruleTime.timeType] }} {{ info.ruleTime.appointmentStartTime.substring(0, 5) }}-{{ info.ruleTime.appointmentEndTime.substring(0, 5) }}</div>
            <div class="popover_header_title_room">{{ info.clinic.clinicName }}</div>
          </div>
          <div class="popover_header_tips">提前{{ info.ruleTime.releaseDay }}天 {{ info.ruleTime.releasePointTime.substring(0, 5) }}放号</div>
        </div>
        <div class="popover_content">
          <div v-if="info.ruleType === '1'" class="popover_content_list">
            <div v-for="source in sourceList" :key="source.key" v-if="info[source.key].isRegistration === '1'" class="popover_list_item">
              <div class="popover_list_item_name">{{ source.label }}</div>
              <div class="popover_list_item_num">{{ info[source.key].number }}个</div>
              <div class="popover_list_item_price">￥{{ info[source.key].price }}<span class="popover_list_item_price_tag">(普通)</span></div>
              <div class="popover_list_item_addPrice">￥{{ info[source.key].raisePrice }}<span class="popover_list_item_price_tag">(加号)</span></div>
            </div>
          </div>
          <div class="popover_content_increase" v-if="info.increaseSchedulingItem && info.ruleType === '1'">
            <div>
              <span class="popover_content_increase_title">{{ info.increaseSchedulingItem.increaseStartTime }}-{{ info.increaseSchedulingItem.increaseEndTime }}&ensp;{{ info.clinic.clinicName }}</span>
              <span class="popover_content_increase_tips">正常排班号满后放号</span>
            </div>
            <div class="popover_content_increase_list" v-for="source in sourceList" :key="source.key" v-if="info.increaseSchedulingItem[source.increaseKey] && info.increaseSchedulingItem[source.increaseKey].isRegistration === '1'">
              <div class="popover_list_item_name">{{ source.label }}加号</div>
              <div class="popover_list_item_num">{{ info.increaseSchedulingItem[source.increaseKey].number }}个</div>
              <div class="popover_list_item_price">￥{{ info.increaseSchedulingItem[source.increaseKey].price }}</div>
            </div>
          </div>
          <div class="popover_content_footer">
            <div class="popover_content_footer_btn" @click="toEdit">修改</div>
            <div class="popover_content_footer_btn" @click="toDelete">删除</div>
          </div>
        </div>
      </div>
      <div slot="reference" :class="{ card: true, physio: info.ruleType === '2' }">
        <div v-if="info.increaseSchedulingItem && info.increaseSchedulingItem.increaseTimeType == 1" class="mb8">
          <div class="card_label">{{ timeTypeMap[info.ruleTime.timeType] }} {{ info.increaseSchedulingItem.increaseStartTime }}-{{ info.increaseSchedulingItem.increaseEndTime }} {{ info.clinic.clinicName }}</div>
          <div v-if="info.ruleType === '1'" class="card_list">
            <div v-for="source in sourceList" :key="source.key" v-if="info.increaseSchedulingItem[source.increaseKey] && info.increaseSchedulingItem[source.increaseKey].isRegistration === '1'" class="card_term">
              <div class="card_term_name">{{ source.label }}加号</div>
              <div class="card_term_num">{{ info.increaseSchedulingItem[source.increaseKey].number }}个</div>
              <div class="card_term_price">￥{{ info.increaseSchedulingItem[source.increaseKey].price }}</div>
            </div>
          </div>
        </div>
        <div>
          <div class="card_label">{{ timeTypeMap[info.ruleTime.timeType] }} {{ info.ruleTime.appointmentStartTime.substring(0, 5) }}-{{ info.ruleTime.appointmentEndTime.substring(0, 5) }} {{ info.clinic.clinicName }}</div>
          <div v-if="info.ruleType === '1'" class="card_list">
            <div v-for="source in sourceList" :key="source.key" v-if="info[source.key].isRegistration === '1'" class="card_term">
              <div class="card_term_name">{{ source.label }}</div>
              <div class="card_term_num">{{ info[source.key].number }}个</div>
              <div class="card_term_price">￥{{ info[source.key].price }}</div>
            </div>
          </div>
        </div>
        <div v-if="info.increaseSchedulingItem && info.increaseSchedulingItem.increaseTimeType == 2" class="mt8">
          <div class="card_label">{{ timeTypeMap[info.ruleTime.timeType] }} {{ info.increaseSchedulingItem.increaseStartTime }}-{{ info.increaseSchedulingItem.increaseEndTime }} {{ info.clinic.clinicName }}</div>
          <div v-if="info.ruleType === '1'" class="card_list">
            <div v-for="source in sourceList" :key="source.key" v-if="info.increaseSchedulingItem[source.increaseKey] && info.increaseSchedulingItem[source.increaseKey].isRegistration === '1'" class="card_term">
              <div class="card_term_name">{{ source.label }}加号</div>
              <div class="card_term_num">{{ info.increaseSchedulingItem[source.increaseKey].number }}个</div>
              <div class="card_term_price">￥{{ info.increaseSchedulingItem[source.increaseKey].price }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
  export default {
    name: 'scheduleRulesCard',
    props: {
      week: {
        type: String,
        default: ''
      },
      info: {
        type: Object,
        default: () => ({
          vId: '',
          id: '',
          dept: {
            deptId: '',
            deptName: ''
          },
          doctor: {
            doctorId: '',
            doctorName: ''
          },
          clinic: {
            clinicId: '',
            clinicName: '',
          },
          ruleTime: {
            timeType: '1',
            appointmentStartTime: '',
            appointmentEndTime: '',
            timeQuantumCode: '4',
            releaseDay: '15',
            releasePointTime: '00:00'
          },
          generalVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          physicalVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          contributingVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          freeVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          transferVo: {
            isRegistration: '0',
            number: '',
            addNumber:'',
            price: '',
            raisePrice: ''
          },
          ruleType: '1',
          delFlag: '0',
          isIncrease:false,
          increaseSchedulingItem:null
        })
      }
    },
    data() {
      return {
        timeTypeMap: {
          '1': '上午',
          '2': '中午',
          '3': '下午',
          '4': '晚上'
        },
        sourceList: [
          {
            label: '普通',
            key: 'generalVo',
            increaseKey:'commonIncrease'
          },
          {
            label: '理疗',
            key: 'physicalVo',
            increaseKey:'physicalIncrease'
          },
          {
            label: '特约',
            key: 'contributingVo',
            increaseKey:'contributingIncrease'
          },
          {
            label: '义诊',
            key: 'freeVo',
            increaseKey:'freeIncrease'
          },
          {
            label: '转方',
            key: 'transferVo',
            increaseKey:'transferIncrease'
          }
        ]
      }
    },
    methods: {
      toEdit () {
        let data = JSON.parse(JSON.stringify(this.info))
        data = {
          ...data,
          type: 'edit',
          week: this.week
        }
        this.$emit('scheduleEdit', data)
      },
      toDelete () {
        let data = JSON.parse(JSON.stringify(this.info))
        data = {
          ...data,
          week: this.week
        }
        this.$emit('scheduleDelete', data)
      }
    }
  }
</script>

<style lang="less" scoped>
  .scheduleRulesCard {
    position: relative;
    z-index: 1;
    width: 100%;
  }

  .card {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    padding: 8px 10px;
    width: 100%;
    background-color: #DFF0FF;
    border-radius: 4px;
    overflow: hidden;
  }

  .card::before {
    content: '';
    display: block;
    position: absolute;
    z-index: 2;
    left: 0px;
    top: 0px;
    bottom: 0px;
    width: 3px;
    background-color: #1890FF;
  }

  .card.physio {
    background-color: #E2F8E0;
  }

  .card.physio::before {
    background-color: #29C01B;
  }

  .card_label {
    line-height: 18px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .card_list {
    margin: 6px 0 0 0;
    width: 100%;
  }

  .card_term {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .card_term::before {
    content: '';
    display: block;
    width: 4px;
    height: 4px;
    background-color: #1890FF;
    border-radius: 50%;
    overflow: hidden;
  }

  .card_term+.card_term {
    margin: 8px 0 0 0;
  }

  .card_term_name {
    margin: 0 0 0 4px;
    line-height: 13px;
    font-size: 13px;
    color: #626262;
  }

  .card_term_num {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 0 8px;
    width: 36px;
    line-height: 13px;
    font-size: 13px;
    color: #626262;
  }

  .card_term_price {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 8px;
    width: 36px;
    line-height: 13px;
    font-size: 13px;
    color: #626262;
  }

  .popover {
    padding: 0px;
    width: fit-content;
  }

  .popover_info {
    width: fit-content;
    min-width: 320px;
  }

  .popover_header {
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    background-color: #1890FF;
  }

  .popover_header.physio {
    background-color: #29C01B;
  }

  .popover_header_title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .popover_header_title_tag {
    box-sizing: border-box;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 6px;
    height: 20px;
    font-size: 13px;
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
    border-radius: 2px;
  }

  .popover_header_title_time {
    flex-shrink: 0;
    margin: 0 0 0 8px;
    line-height: 16px;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
  }

  .popover_header_title_room {
    margin: 0 0 0 8px;
    line-height: 16px;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
  }

  .popover_header_tips {
    margin: 8px 0 0 0;
    line-height: 13px;
    font-size: 13px;
    color: rgba(255,255,255,0.9);
  }

  .popover_content {
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    background-color: #FFFFFF;
  }

  .popover_content_list {
    width: 100%;
  }

  .popover_list_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .popover_list_item::before {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    background-color: #1890FF;
    border-radius: 50%;
    overflow: hidden;
  }

  .popover_list_item+.popover_list_item {
    margin: 10px 0 0 0;
  }

  .popover_list_item_name {
    margin: 0 0 0 6px;
    line-height: 14px;
    font-size: 14px;
    color: #000000;
  }

  .popover_list_item_num {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 0 10px;
    width: 40px;
    line-height: 14px;
    font-size: 14px;
    color: #000000;
  }

  .popover_list_item_price {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 0 10px;
    width: 80px;
    line-height: 14px;
    font-size: 14px;
    color: #000000;
  }

  .popover_list_item_addPrice {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 0 0 0 8px;
    width: 80px;
    line-height: 14px;
    font-size: 14px;
    color: #000000;
  }

  .popover_list_item_price_tag {
    color: #667182;
  }

  .popover_content_footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    margin-top: 24px;
  }

  // .popover_content_list+.popover_content_footer {
  //   margin: 24px 0 0 0;
  // }

  .popover_content_footer_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    height: 28px;
    font-size: 14px;
    color: #1F2329;
    border: 1px solid #D3D3D5;
    border-radius: 2px;
    cursor: pointer;
  }

  .popover_content_footer_btn+.popover_content_footer_btn {
    margin: 0 0 0 12px;
  }
  .popover_content_increase{
    padding: 12px;
    background: #F7F8F9;
    margin-top: 16px;
    border-radius: 2px;
  }
  .popover_content_increase_list{
    display: flex;
    align-items: center;
    margin-top: 8px;
  }
  .popover_content_increase_list::before {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    background-color: #1890FF;
    border-radius: 50%;
    overflow: hidden;
  }
  .popover_content_increase_title{
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }
  .popover_content_increase_tips{
    margin-left: 6px;
    font-weight: 400;
    font-size: 12px;
    color: #667182;
  }
</style>

<style lang="less">
  .scheduleRulesCard_popper{
    padding: 0px;
    border-radius: 4px;
    background-color: #FFFFFF;
    border: none;
    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
    overflow: hidden;
  }
  .scheduleRulesCard_popper[x-placement^=left] {
    margin-right: -10px!important;
  }
  .scheduleRulesCard_popper[x-placement^=right] {
    margin-left: -10px!important;
  }
</style>